/**
 * Accounting / tax / payroll factual guardrails.
 * Keep volatile rates, filing dates and thresholds out of evergreen copy.
 */
// Legacy consumers use these as content-edit timestamps, not certification
// that all linked authorities were consulted on that date.
export const ACCOUNTING_REVIEWED_TH = "8 ตุลาคม 2569";
export const ACCOUNTING_REVIEWED_ISO = "2026-10-08T03:02:00.000Z";

export const ACCOUNTING_SOURCES = [
  {
    name: "กรมพัฒนาธุรกิจการค้า (DBD)",
    site: "dbd.go.th",
    url: "https://www.dbd.go.th/",
    scope: "การจัดทำบัญชี การนำส่งงบการเงิน และข้อมูลนิติบุคคล",
  },
  {
    name: "กรมสรรพากร",
    site: "rd.go.th",
    url: "https://www.rd.go.th/",
    scope: "ภาษีมูลค่าเพิ่ม ภาษีเงินได้ ภาษีหัก ณ ที่จ่าย และแบบภาษี",
  },
  {
    name: "สำนักงานประกันสังคม",
    site: "sso.go.th",
    url: "https://www.sso.go.th/",
    scope: "การขึ้นทะเบียนนายจ้าง ผู้ประกันตน และเงินสมทบ",
  },
  {
    name: "สภาวิชาชีพบัญชี",
    site: "tfac.or.th",
    url: "https://www.tfac.or.th/",
    scope: "มาตรฐานการรายงานทางการเงินและมาตรฐานการสอบบัญชี",
  },
  {
    name: "สำนักงานคณะกรรมการส่งเสริมการลงทุน (BOI)",
    site: "boi.go.th",
    url: "https://www.boi.go.th/",
    scope: "เงื่อนไขบัตรส่งเสริมและการใช้สิทธิประโยชน์ของกิจการที่ได้รับส่งเสริม",
  },
  {
    name: "Income Tax Department, Government of India",
    site: "incometax.gov.in",
    url: "https://www.incometax.gov.in/",
    scope: "ข้อมูล PAN และภาษีเงินได้ของอินเดีย",
  },
  {
    name: "Protean eGov Technologies",
    site: "protean-tinpan.com",
    url: "https://www.protean-tinpan.com/",
    scope: "ช่องทางคำขอ PAN ที่ได้รับมอบหมายและข้อกำหนดเอกสาร",
  },
] as const;

export const ACCOUNTING_VOLATILE_NOTE =
  "อัตราภาษี อัตราเงินสมทบ แบบฟอร์ม วันครบกำหนด และเกณฑ์ยกเว้นอาจเปลี่ยนตามกฎหมาย ประกาศ หรือช่องทางยื่น โปรดตรวจสอบฉบับปัจจุบันกับหน่วยงานเจ้าของเรื่องก่อนดำเนินการทุกครั้ง";

export const ACCOUNTING_QUOTE_NOTE =
  "ค่าบริการประเมินตามขอบเขตงาน ปริมาณเอกสาร และความซับซ้อน สอบถามเจ้าหน้าที่ทางโทรศัพท์ LINE หรืออีเมล";

export const PAN_CARD_NOTE =
  "PAN เป็นหมายเลขประจำตัวผู้เสียภาษีของอินเดีย การมี PAN ไม่ใช่หลักฐานสัญชาติอินเดีย ไม่ใช่ใบอนุญาตพำนัก และไม่รับประกันว่าธนาคารหรือหน่วยงานใดจะอนุมัติธุรกรรม ผู้ยื่นจากประเทศไทยต้องเลือกแบบคำขอและหลักฐานตามสถานะบุคคลหรือนิติบุคคล ตรวจฉบับล่าสุดที่ incometax.gov.in และผู้ให้บริการคำขอที่ได้รับมอบหมาย";
